/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function DotsHorizontal({
    className = null,

}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M10.8 7.20005C11.4627 7.20005 12 6.66279 12 6.00005C12 5.33731 11.4627 4.80005 10.8 4.80005C10.1373 4.80005 9.6 5.33731 9.6 6.00005C9.6 6.66279 10.1373 7.20005 10.8 7.20005Z" fill="currentColor" />
            <path d="M6 7.20005C6.66274 7.20005 7.2 6.66279 7.2 6.00005C7.2 5.33731 6.66274 4.80005 6 4.80005C5.33726 4.80005 4.8 5.33731 4.8 6.00005C4.8 6.66279 5.33726 7.20005 6 7.20005Z" fill="currentColor" />
            <path d="M1.2 7.20005C1.86274 7.20005 2.4 6.66279 2.4 6.00005C2.4 5.33731 1.86274 4.80005 1.2 4.80005C0.537258 4.80005 0 5.33731 0 6.00005C0 6.66279 0.537258 7.20005 1.2 7.20005Z" fill="currentColor" />
        </svg>
    );
}
